<button class="p-2 px-4 rounded-[10px] text-white bg-[#808080] w-full">
  <ng-content></ng-content>
</button>
